import e from "./string-to-slug.mjs";
function r(A) {
  return `${e(process.env.APPLICATION_NAME || process.env.NEXT_PUBLIC_APPLICATION_NAME || process.env.REACT_APP_APPLICATION_NAME || "APPNAME")}__${A}`;
}
export {
  r as createClasses
};
